import React from "react";
import { useDrag, useDrop } from "react-dnd";
import styled from "styled-components";

import { ImportAdsBlock } from "./ImportBlock/ImportAdsBlock";

const Container = styled.div``;

const BlockItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  flex-shrink: 0;
  border-radius: 16px;
  background: linear-gradient(181deg, #fff 50%, #e9fff9 99.52%), #fff;
  box-shadow: 0px 4px 16px 0px #def4f5;
  cursor: grab;
`;

export const DraggableBlock = ({
  item,
  index,
  moveBlock = () => undefined,
  campaignWidth,
  campaignHeight,
  onHandleOpenModal = () => undefined,
  onHandleUpdateBlockInputValue = () => undefined,
  onHandleDeleteBlock = () => undefined,
  onHandleFullFrameBlock = () => undefined,
}) => {
  const [, ref] = useDrag({
    type: "BLOCK",
    item: { index },
  });

  const [, drop] = useDrop({
    accept: "BLOCK",
    hover: (draggedItem) => {
      if (draggedItem?.index !== index) {
        moveBlock(draggedItem?.index, index);
        draggedItem.index = index;
      }
    },
  });

  return (
    <Container ref={(node) => ref(drop(node))}>
      <BlockItem>
        <ImportAdsBlock
          item={item}
          index={index}
          campaignWidth={campaignWidth}
          campaignHeight={campaignHeight}
          onHandleOpenModal={onHandleOpenModal}
          onHandleUpdateBlockInputValue={onHandleUpdateBlockInputValue}
          onHandleDeleteBlock={onHandleDeleteBlock}
          onHandleFullFrameBlock={onHandleFullFrameBlock}
        />
      </BlockItem>
    </Container>
  );
};
